export default __webpack_public_path__ + "static/media/point.384ec689b5442adc0e4d662795638398.svg";